import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const TimeRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
`

export const TimeRow = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  color: ${ (props) => props.theme.colors.standardSchwarz };
  margin: 0 0 10px;
  > * {
    flex-basis: 50%;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
    flex-direction: column;
    width: auto;
    margin: 0 24px 15px 0;

    > * {
      flex-basis: auto;
    }
  }
`

export const TimeRowTitle = styled.div`
  font-weight: bolder;
  margin-bottom: 10px;
`

export const TimeRowList = styled.ul`
  padding-left: 0;
  list-style-type: none;
  margin: 0;
`

export const TimeRowListItem = styled.li`
  margin-top: 0;
  color: ${ (props) =>
    'geschlossen' === props.time
      ? props.theme.colors['panel-inner-border']
      : props.theme.colors['standard-schwarz'] };
`

export const TimeRowListAppointment = styled.div`
  font-weight: bolder;
  margin-top: 5px;
  margin-bottom: 15px;
`

export const TimeRowListHint = styled.p`
  margin-bottom: 0;
  color: ${ (props) => props.theme.colors['panel-inner-border'] };
`
